/* eslint-disable max-lines */
import { useContext, useEffect, useState } from 'react';
import { Box, Button, Grid, IconButton, Snackbar, Typography, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';
import { ProductHeading } from './LeadGeneration/ProductHeading/ProductHeading';
import StepperWizard from './Wizard/StepperWizard';
import LeadGenerationContext from '../context/LeadGenerationContext';
import { CommonStyles } from './LeadGeneration/CommonStyles';
import {
  BACK,
  BUSINESS_COMPLIANCE_INFO,
  COLOR1,
  CONTINUE,
  PERSONAL_INFO,
  PROGRESA_CONTIGO,
  SAVEYOURAPPLICATION,
} from '../constants';
import Loader from './Loader/Loader';
import {
  productHeadingInfo,
  productSubHeadingInfo,
  productSubHeadingInfoCDIRA,
} from './LeadGeneration/ProductHeading/ProductHeadingStyles';
import {
  commonTernary,
  getRoot,
  isCDIraproduct,
  isCDproduct,
  isIRAEducativaProduct,
  isIRAProduct,
  isWebComponentFlow,
} from './commonCode';
import BookmarkIcon from '../images/BookmarkIcon.png';
import BookmarkIconDisable from '../images/disableiconsavebtn.svg';
import SaveContinueIcon from '../images/saveContinueIcon.svg';
import { productMapping } from '../services/productMapping';
import { dgiMapping } from '../services/dgiMapping';
import SimpleTextModal from './Modal/SimpleTextModal';
import SnackbarCloseIcon from '../images/Close.svg';
import snackbarInfo from '../images/info-return.svg';
import { ReturnToSavedApplicationStyles as snackClasses } from './SaveAndContinue/ReturnToSavedApplicationStyles';
import { businessMapping } from '../services/businessMapping';
import Header from '../WebComponents/components/Header';

// eslint-disable-next-line react/prop-types
const Layout = (props) => {
  const {
    children,
    consent,
    ariaDescribedby,
    headingId,
    ariaDescribedbyId,
    classes,
    descriptionKey,
    descriptionValue,
    stepValue,
    handleBack,
    handleSaveApplication,
    handleContinue,
    disableCondition,
    continueBtnTestid,
    backBtnTestid,
    saveApplicationTestId,
    screenLoading,
    layoutImage,
  } = props;
  const baseContext = isWebComponentFlow();
  const {
    productName,
    currentPage,
    flowInvitation,
    isApplicationSaved,
    savedDataFlow,
    continueModal,
    userSavedPage,
    complianceData,
    productData,
    flowTypeETB,
    disableContinue,
    termsAndConditionPreSignedURL,
    islibrePlusJourney,
    theme,
    isLibreOptional,
  } = baseContext;
  const styledClasses = CommonStyles(theme);
  const { t } = useTranslation();
  const themes = useTheme();

  const isMobile = useMediaQuery(themes?.breakpoints?.down('sm'), {
    defaultMatches: true,
  });

  const isTab = useMediaQuery(themes?.breakpoints?.between('sm', 'md'), {
    defaultMatches: true,
  });

  const isCDIRA = isCDIraproduct(productName);
  const isCDTab = isTab && isCDIRA;
  const isEducativeReview = isIRAEducativaProduct(productName) && currentPage === 'cd-review';
  const isEducativeReviewTab = isEducativeReview && isTab;

  const productCondition = `${t(productName, { defaultValue: productName })} - ${t('Invitation', {
    defaultValue: 'Invitation',
  })}`;
  const contigoStartPage = productName === PROGRESA_CONTIGO && currentPage === PERSONAL_INFO;
  const [snackbarstate, setSnackbarstate] = useState(false);
  const [resizePaddingTop, setResizePaddingTop] = useState('');

  const handleClose = () => {
    setSnackbarstate(false);
  };
  useEffect(() => {
    const query = new URLSearchParams(window.location.search);
    const element = getRoot()?.querySelector('[data-page]');
    if (element) {
      setResizePaddingTop(element.style.paddingTop);
      if (
        element.getAttribute('data-page') === userSavedPage &&
        query.get('returnTopage') === userSavedPage
      ) {
        setSnackbarstate(true);
      }
    }
  }, [complianceData, productData]);
  useEffect(() => {
    const element = getRoot()?.querySelector('[data-page]');
    if (element) {
      if (snackbarstate) {
        element.style.paddingTop = '105px';
      } else {
        element.style.paddingTop = resizePaddingTop;
      }
    }
  }, [snackbarstate, complianceData, productData]);
  const getPage = () => {
    let returnPage;
    if (userSavedPage === 'address-info' || userSavedPage === 'personal-info') {
      returnPage = true;
    } else {
      returnPage = false;
    }
    return returnPage;
  };

  return (
    <>
      <Box
        component="div"
        className={baseContext?.wcFlow ? 'custom-container-empty' : 'custom-container-new'}
        role="main"
        aria-describedby={ariaDescribedby}
      >
        <Box
          component="div"
          className="secondary-container-new"
          sx={(isCDTab || isEducativeReviewTab) && { padding: '25px 0px 25px 5px !important' }}
        >
          {consent ? (
            <>
              {baseContext?.wcFlow && (
                <Box sx={styledClasses.webHeaderStyle}>
                  <Header />
                </Box>
              )}
              <Typography
                id="screenSixHeading"
                variant={!isCDIRA && 'h5'}
                sx={isCDIRA ? productSubHeadingInfoCDIRA : productSubHeadingInfo}
              >
                {t('Your Consent', { defaultValue: 'Your Consent' })}
              </Typography>
              <Typography
                id="screenSixDesc"
                variant="subtitle1"
                sx={productSubHeadingInfo}
                style={isCDIRA ? { marginTop: '12px' } : null}
              >
                {t(descriptionKey, {
                  defaultValue: descriptionValue,
                  nsSeparator: '|',
                })}
              </Typography>
            </>
          ) : (
            <ProductHeading
              id={isLibreOptional ? undefined : headingId}
              ariaDescribedbyId={ariaDescribedbyId}
              productName={
                isLibreOptional
                  ? t('Fund your new account', { defaultValue: 'Fund your new account' })
                  : commonTernary(
                      flowInvitation === 'invitation-form',
                      `${productCondition}`,
                      t(`${productName}`, { defaultValue: `${productName}` })
                    )
              }
              stepDescription={
                isLibreOptional
                  ? t('How do you want to make your first deposit to your Libre Account?', {
                      defaultValue:
                        'How do you want to make your first deposit to your Libre Account?',
                      nsSeparator: '|',
                    })
                  : t(descriptionKey, {
                      defaultValue: descriptionValue,
                      nsSeparator: '|',
                    })
              }
            />
          )}
          {currentPage !== 'upload-documents-later' && !isLibreOptional ? (
            <Grid container>
              <Grid size={{ xs: 12, md: 8, sm: 8 }}>
                <Grid className="stepperLayoutStyles">
                  <StepperWizard steps={stepValue} />
                </Grid>
              </Grid>
            </Grid>
          ) : (
            ''
          )}
          <Grid container sx={styledClasses.marginTopGrid}>
            <Grid
              size={{ xs: 12, md: 8, sm: isCDIRA || isEducativeReview ? 10 : 8 }}
              style={{ position: 'relative' }}
              sx={styledClasses.snackBarMobile}
            >
              {snackbarstate && (
                <Snackbar
                  id="snackbarId"
                  data-testid="snackbar_testid"
                  open={snackbarstate}
                  anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
                  sx={
                    getPage() ? snackClasses.snackbarPositionMobile : snackClasses.snackbarPosition
                  }
                  classes={{ root: snackClasses.snackbarReturnRoot }}
                  // onClose={handleClose}
                  slotProps={{
                    content: {
                      sx: snackClasses.snackbarRetunStyleViaContentProps,
                      style: { minWidth: 'auto' },
                    },
                  }}
                  action={
                    <IconButton
                      id="closeIconId"
                      style={{ position: 'absolute', right: '16px', top: '16px' }}
                      size="small"
                      color={COLOR1}
                      onClick={handleClose}
                      data-testid="snackbarclose_testid"
                    >
                      <img
                        id="closeImgId"
                        src={SnackbarCloseIcon}
                        height="16px"
                        width="16px"
                        alt={t('close')}
                      />
                    </IconButton>
                  }
                  message={
                    <Box component="div" sx={[snackClasses.message, snackClasses.dd]}>
                      <span style={{ marginRight: '12px' }}>
                        <IconButton
                          classes={{ sizeSmall: snackClasses.snackBarBtn }}
                          style={{ marginTop: 0 }}
                          size="small"
                          color={COLOR1}
                        >
                          <img src={snackbarInfo} alt="Icon" height="24px" width="24px" />
                        </IconButton>
                      </span>
                      <span style={{ marginRight: '6%', fontSize: '16px' }}>
                        {t('Continue your application process from where you left!', {
                          defaultValue: 'Continue your application process from where you left!',
                        })}
                      </span>
                    </Box>
                  }
                />
              )}
              {children}
              <Grid
                container
                sx={styledClasses.button_grid}
                direction="row"
                alignItems="center"
                // style={
                //   {
                // display: 'flex',
                // flexWrap: 'nowrap',
                // justifyContent: 'flex-end',
                // }
                // }
              >
                <Grid
                  container
                  sx={styledClasses.saveButtonBox}
                  size={{ xs: 12 }}
                  // style={{
                  //   display: 'flex',
                  //   flexWrap: 'nowrap',
                  //   // justifyContent: 'flex-end',
                  // }}
                >
                  {!isApplicationSaved &&
                  !isLibreOptional &&
                  productMapping(productName) !== 'Progresa Contigo' &&
                  dgiMapping(productName) !== 'DGI Contribution' &&
                  businessMapping(productName) !== 'Prestamo Comercial' &&
                  businessMapping(productName) !== 'Tarjeta de Credito Comercial' &&
                  businessMapping(productName) !== 'Linea de Credito Comercial' &&
                  !contigoStartPage &&
                  currentPage !== 'upload-documents-later' &&
                  currentPage !== 'business-info' &&
                  currentPage !== 'contact-info' &&
                  currentPage !== 'invi-flow-info' &&
                  currentPage !== BUSINESS_COMPLIANCE_INFO &&
                  (flowTypeETB === '' || flowTypeETB === 'NtbFlow') &&
                  // !(
                  //   baseContext.productName === 'Consumer Credit' &&
                  //   (currentPage === 'document-checklist' && !isClicked)
                  // ) &&
                  !savedDataFlow ? (
                    <Grid item sx={[styledClasses.mobileButtons, styledClasses.backBtnGrid]}>
                      <Button
                        disableFocusRipple
                        disabled={
                          currentPage === 'address-info' || currentPage === 'business-comp'
                            ? disableContinue
                            : false
                        }
                        onClick={handleSaveApplication}
                        data-testid={saveApplicationTestId}
                        sx={
                          (currentPage === 'address-info' || currentPage === 'business-comp') &&
                          disableContinue
                            ? styledClasses.saveApplicationButtonDIS
                            : styledClasses.saveApplicationButton
                        }
                      >
                        <div
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                          }}
                        >
                          <img
                            src={
                              (currentPage === 'address-info' || currentPage === 'business-comp') &&
                              disableContinue
                                ? BookmarkIconDisable
                                : BookmarkIcon
                            }
                            alt="blub"
                          />

                          <span style={{ marginLeft: '10px', whiteSpace: 'nowrap' }}>
                            {t(SAVEYOURAPPLICATION, { defaultValue: SAVEYOURAPPLICATION })}
                          </span>
                        </div>
                      </Button>
                    </Grid>
                  ) : (
                    ''
                  )}
                  {isApplicationSaved &&
                    !isLibreOptional &&
                    productMapping(productName) !== 'Progresa Contigo' &&
                    dgiMapping(productName) !== 'DGI Contribution' &&
                    businessMapping(productName) !== 'Prestamo Comercial' &&
                    businessMapping(productName) !== 'Tarjeta de Credito Comercial' &&
                    businessMapping(productName) !== 'Linea de Credito Comercial' &&
                    !contigoStartPage &&
                    currentPage !== 'upload-documents-later' &&
                    currentPage !== 'business-info' &&
                    (currentPage !== 'contact-info' || isIRAProduct(productName)) &&
                    currentPage !== 'invi-flow-info' &&
                    currentPage !== BUSINESS_COMPLIANCE_INFO &&
                    // !(
                    //   baseContext.productName === 'Consumer Credit' &&
                    //   currentPage === 'document-checklist' &&
                    //   !isClicked
                    // ) &&

                    !savedDataFlow && (
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <img width="24px" height="24px" src={SaveContinueIcon} alt="blub" />
                        <Typography
                          sx={styledClasses.text_style_saveConti}
                          style={{ textAlign: 'start' }}
                          aria-label={t('Your application process', {
                            defaultValue: 'Your application process',
                          })}
                        >
                          {t('Your application process will auto save', {
                            defaultValue: 'Your application process will auto save',
                          })}
                        </Typography>
                      </div>
                    )}
                  {!isApplicationSaved &&
                    !isLibreOptional &&
                    productMapping(productName) !== 'Progresa Contigo' &&
                    dgiMapping(productName) !== 'DGI Contribution' &&
                    businessMapping(productName) !== 'Prestamo Comercial' &&
                    businessMapping(productName) !== 'Tarjeta de Credito Comercial' &&
                    businessMapping(productName) !== 'Linea de Credito Comercial' &&
                    !contigoStartPage &&
                    currentPage !== 'upload-documents-later' &&
                    currentPage !== 'business-info' &&
                    (currentPage !== 'contact-info' || isIRAProduct(productName)) &&
                    currentPage !== 'invi-flow-info' &&
                    currentPage !== BUSINESS_COMPLIANCE_INFO &&
                    // !(
                    //   baseContext.productName === 'Consumer Credit' &&
                    //   currentPage === 'document-checklist' &&
                    //   !isClicked
                    // ) &&
                    savedDataFlow && (
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <img width="24px" height="24px" src={SaveContinueIcon} alt="blub" />
                        <Typography
                          sx={styledClasses.text_style_saveConti}
                          style={{ textAlign: 'start' }}
                          aria-label={t('Your application process', {
                            defaultValue: 'Your application process',
                          })}
                        >
                          {t('Your application process will auto save', {
                            defaultValue: 'Your application process will auto save',
                          })}
                        </Typography>
                      </div>
                    )}
                </Grid>
                <Grid
                  container
                  style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px' }}
                  size={{ xs: 12 }}
                  sx={
                    consent
                      ? clsx(styledClasses.consentButtonGrid)
                      : classes.personal_button_container
                  }
                >
                  {!contigoStartPage &&
                  currentPage !== 'upload-documents-later' &&
                  currentPage !== 'business-info' &&
                  (currentPage !== 'contact-info' || isIRAProduct(productName)) &&
                  currentPage !== 'invi-flow-info' &&
                  !(islibrePlusJourney && currentPage === 'product-info') ? (
                    <Grid item sx={[styledClasses.mobileButtons, styledClasses.backBtnGrid]}>
                      <Button
                        disableFocusRipple
                        sx={
                          currentPage === 'personal-info-consumer'
                            ? styledClasses.back_button_Consumer
                            : commonTernary(
                                consent,
                                [styledClasses.back_button, styledClasses.consentButtons],
                                [styledClasses.back_button]
                              )
                        }
                        onClick={handleBack}
                        data-testid={backBtnTestid}
                        style={{ margin: '0px' }}
                      >
                        {t(BACK, { defaultValue: BACK })}
                      </Button>
                    </Grid>
                  ) : (
                    ''
                  )}
                  <Grid item sx={[styledClasses.mobileButtons, styledClasses.ContinueBtnGrid]}>
                    <Button
                      disableFocusRipple
                      disabled={disableCondition}
                      onClick={handleContinue}
                      sx={{
                        '&.Mui-disabled': {
                          ...(currentPage === 'personal-info-consumer'
                            ? styledClasses.next_disabled_button['&.MuiButton-root.Mui-disabled']
                            : (isApplicationSaved || savedDataFlow) && !consent
                            ? styledClasses.save_disabled_button['&.MuiButton-root.Mui-disabled']
                            : styledClasses.disabled_button['&.MuiButton-root.Mui-disabled']),
                        },
                        ...(currentPage === 'personal-info-consumer'
                          ? styledClasses.next_continue_button
                          : (isApplicationSaved || savedDataFlow) && !consent
                          ? { ...styledClasses.save_continue_button, width: '228px' }
                          : styledClasses.continue_button),
                      }}
                      data-testid={continueBtnTestid}
                    >
                      {currentPage === 'personal-info-consumer'
                        ? t('Next: Address info', {
                            defaultValue: 'Next: Address info',
                            nsSeparator: '|',
                          })
                        : currentPage === 'document-checklist' &&
                          !savedDataFlow &&
                          !businessMapping(productName)
                        ? t('Next', {
                            defaultValue: 'Next',
                            nsSeparator: '|',
                          })
                        : t(
                            isCDproduct(productName) &&
                              consent &&
                              termsAndConditionPreSignedURL !== ''
                              ? 'Agree & Submit'
                              : consent || currentPage === 'upload-documents-later'
                              ? 'Submit'
                              : commonTernary(
                                  isApplicationSaved || savedDataFlow,
                                  'Save & Continue',
                                  CONTINUE
                                ),
                            {
                              defaultValue:
                                isCDproduct(productName) &&
                                consent &&
                                termsAndConditionPreSignedURL !== ''
                                  ? 'Agree & Submit'
                                  : consent || currentPage === 'upload-documents-later'
                                  ? 'Submit'
                                  : commonTernary(
                                      isApplicationSaved || savedDataFlow,
                                      'Save & Continue',
                                      CONTINUE
                                    ),
                            }
                          )}
                    </Button>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            {!isMobile && (
              <Grid size={{ xs: 12, sm: isCDIRA || isEducativeReview ? 2 : 4, md: 4 }}>
                <div>
                  <img
                    src={layoutImage}
                    alt="layout"
                    style={{ maxWidth: '100%', height: 'auto' }}
                  />
                </div>
              </Grid>
            )}
          </Grid>
        </Box>
      </Box>
      {!consent && screenLoading && (
        <div className="loader-style">
          <Loader />
        </div>
      )}
      {continueModal && <SimpleTextModal />}
    </>
  );
};

export default Layout;

Layout.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  ariaDescribedby: PropTypes.string,
  layoutImage: PropTypes.string,
  consent: PropTypes.bool,
  headingId: PropTypes.string,
  ariaDescribedbyId: PropTypes.string,
  descriptionKey: PropTypes.string,
  descriptionValue: PropTypes.string,
  backBtnTestid: PropTypes.string,
  saveApplicationTestId: PropTypes.string,
  continueBtnTestid: PropTypes.string,
  classes: PropTypes.object,
  stepValue: PropTypes.number,
  handleBack: PropTypes.func,
  handleSaveApplication: PropTypes.func,
  handleContinue: PropTypes.func,
  disableCondition: PropTypes.bool,
  screenLoading: PropTypes.bool,
};
